import React from 'react';
import './ImpersonateUserRow.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';

export default function ImpersonateUserRow({ showDetail, user }) {
  if (logComponent('ImpersonateUserRow')) { console.debug('ImpersonateUserRow rendered'); }

  const handleButtonClick = () => {
    if (logComponent('ImpersonateUserRow')) { console.debug('ImpersonateUserRow handleButtonClick'); }
    showDetail(user);
  }


  return (
    <React.Fragment>
      <td className="Impersonate-User-Row__cell Impersonate-User-Row__name-cell">
        <span className="Impersonate-User-Row__name">{user.legalFirstName} {user.lastName}
        </span>
      </td>
      <td className="Impersonate-User-Row__cell Impersonate-User-Row__name-cell">
        <span className="Impersonate-User-Row__email">{user.emailAddress}</span>
      </td>
    </React.Fragment>
  );
}